import { useCallback, useEffect, useRef } from "react";

export const useAutofocusOnOpen = (enabled, delay = 50) => {
  const ref = useRef(null);
  const timeoutRef = useRef(null);

  const clearFocusTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const focusInput = useCallback(() => {
    clearFocusTimeout();
    timeoutRef.current = setTimeout(() => {
      ref.current?.focus?.({ preventScroll: true });
    }, delay);
  }, [clearFocusTimeout, delay]);

  const setRef = useCallback(
    (node) => {
      ref.current = node;
      if (node && enabled) {
        focusInput();
      }
    },
    [enabled, focusInput]
  );

  useEffect(() => {
    if (!enabled) return undefined;

    focusInput();

    return clearFocusTimeout;
  }, [clearFocusTimeout, enabled, focusInput]);

  useEffect(() => clearFocusTimeout, [clearFocusTimeout]);

  return setRef;
};
